import {EventDTO} from './api/event-api.service';

export type FeeCategory = 'adults' | 'children' | 'seniors';

export interface FeeLine {
    category: FeeCategory;
    label: string;
    count: number;
    unitPrice: number;
    subtotal: number;
}

export function getUnitFee(event: EventDTO | null | undefined, category: FeeCategory): number {
    const raw = category === 'adults' ? event?.eventFeeAdult
        : category === 'children' ? event?.eventFeeChild
        : event?.eventFeeSeniorCitizen;
    const fee = Number(raw || 0);
    return Number.isFinite(fee) && fee > 0 ? fee : 0;
}

// One line per category, using the same counts x unit fees as the fees subtotal. Rows are included
// when the category has a count or a fee; a $0-fee, 0-count category is omitted to keep the list tight.
export function buildFeeLines(event: EventDTO | null | undefined,
                              counts: Record<FeeCategory, number>,
                              labels: Record<FeeCategory, string>): FeeLine[] {
    return (['adults', 'children', 'seniors'] as FeeCategory[])
        .map(category => {
            const unitPrice = getUnitFee(event, category);
            const count = counts[category];
            return {category, label: labels[category], count, unitPrice, subtotal: count * unitPrice};
        })
        .filter(line => line.count > 0 || line.unitPrice > 0);
}

export function sumFeeLines(lines: FeeLine[]): number {
    return lines.reduce((total, line) => total + line.subtotal, 0);
}
